import { render, staticRenderFns } from "./userpassword.vue?vue&type=template&id=faecfa9a&scoped=true"
import script from "./userpassword.vue?vue&type=script&lang=js"
export * from "./userpassword.vue?vue&type=script&lang=js"
import style0 from "./userpassword.vue?vue&type=style&index=0&id=faecfa9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faecfa9a",
  null
  
)

export default component.exports